import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer } from "react-toastify";
import {
  getUsersReport,
} from "../../redux/actions/authAction";

const UsersReport = () => {
  const dispatch = useDispatch(); 
  const today = new Date()
  const [allUsers, setAllUsers] = useState(false);
  const { allOrganizations } = useSelector(
    (state) => state.getOrganizationData
  );
  const { usersReportData } = useSelector(
    (state) => state.getReportsData
  ); 
  const [organizationId, setOrganizationId] = useState(
    allOrganizations?.data?.[0]?._id
  );

  const formatDate = (dateString) => {
    const createdAt = new Date(dateString);
    const optionsDate = { year: 'numeric', month: 'short', day: 'numeric' };

    const date = `${createdAt.toLocaleDateString('en-US', optionsDate)}`

    return date === 'Invalid Date' ? 'No changes made yet' : date;
  };

  useEffect(() => {
    dispatch(getUsersReport({ organizationId, allUsers }));
  }, [dispatch, organizationId, allUsers]);

  return (
    <>
      <>
        <ToastContainer />
      </>
      <div className="manage-user">
        <div className="row mb-3 pt-5 pl-5">
          <div className="col-md-6">
            <h1 className="healthKitUpdateHeaderFont d-flex">
              Users Report
            </h1>
          </div>
        </div>
        <div className="streak-report-main">
          {allOrganizations?.data?.length ? (
            <>
              <div className="organization-report-filter">
                <Form.Label className="d-flex organization-report-filter-heading">
                  Organizations
                </Form.Label>
                <Form.Select
                  onChange={(e) => {
                    if (e.target.value === "all") {
                      setAllUsers(true);
                      setOrganizationId("1");
                    } else {
                      setAllUsers(false);
                      setOrganizationId(e.target.value);
                    }
                  }}
                  aria-label="Default select example"
                  value={allUsers ? "all" : organizationId || ""}
                >
                  {allOrganizations?.data?.map((organization, index) => {
                    return (
                      <option value={organization?._id}>
                        {organization?.organizationName}
                      </option>
                    );
                  })}
                 <option value="all">All Users</option>
                </Form.Select>
              </div>
              <div className="report-engagement-heading">
                <p>Daily Report ({formatDate(today)})</p>
              </div>
              <div className="organization-report-page mt-5">
                <>
                  <div className="user-report-table">
                    {usersReportData?.data?.length !== 0 ? (
                      <>
                        <table>
                          <thead>
                          <tr className="header-row" style={{ margin: "10px", height: "60px" }}>
                            <th
                              rowSpan="2"
                              style={{ textAlign: "center", width: "100px" }}
                            >
                              User Name
                            </th>
                            <th
                              rowSpan="2"
                              style={{ textAlign: "center", padding: "5px", width: "225px" }}
                            >
                              User Email
                            </th>
                            <th
                              rowSpan="2"
                              style={{ textAlign: "center" }}
                            >
                              Streak Value
                            </th>

                            <th colSpan="3" style={{ textAlign: "center", width: "300px" }}>
                              Awareness Content
                            </th>
                            <th colSpan="3" style={{ textAlign: "center", width: "300px" }}>
                              Activity Content
                            </th>
                            <th colSpan="3" style={{ textAlign: "center", width: "300px" }}>
                              Total Content
                            </th> 

                            <th
                              rowSpan="2"
                              style={{ textAlign: "center" }}
                            >
                              Date of last streak change
                            </th>
                            <th
                              rowSpan="2"
                              style={{ textAlign: "center", width: "125px" }}
                            >
                              Back up Streak (value from the last change)
                            </th>
                          </tr>
                          <tr>
                            <th>Avail.</th>
                            <th>Eng.</th>
                            <th>Eng. %</th>

                            <th>Avail.</th>
                            <th>Eng.</th>
                            <th>Eng. %</th>

                            <th>Avail.</th>
                            <th>Eng.</th>
                            <th>Eng. %</th>
                          </tr>
                          </thead>
                          <>
                          <tbody>
                            {usersReportData?.data?.map((data, index) => {
                              return (
                                <tr
                                  key={index}
                                  className="whole-row-client"
                                  style={{ borderBottom: "1px solid #f1f5f9" }}
                                >
                                  <td style={{ color: "blue", wordBreak: "break-word" }}>
                                    {data?.userName}
                                  </td>
                                  <td style={{ color: "blue", wordBreak: "break-word" }}>
                                    {data?.userEmail}
                                  </td>
                                  <td style={{ color: "blue", textAlign: "center" }}>
                                    {data?.streakValue}
                                  </td>

                                  <td style={{ textAlign: "center" }}>{data?.read.available}</td>
                                  <td style={{ textAlign: "center" }}>{data?.read.engaged}</td>
                                  <td style={{ textAlign: "center" }}>  
                                    {data?.read?.percentage 
                                    ? data.read.percentage
                                    : 0}% 
                                  </td>

                                  <td style={{ textAlign: "center" }}>{data?.activity.available}</td>
                                  <td style={{ textAlign: "center" }}>{data?.activity.engaged}</td>
                                  <td style={{ textAlign: "center" }}>  
                                    {data?.activity?.percentage 
                                    ? data.activity.percentage
                                    : 0}% 
                                  </td> 

                                  <td style={{ textAlign: "center" }}>{data?.totalContent.available}</td>
                                  <td style={{ textAlign: "center" }}>{data?.totalContent.engaged}</td>
                                  <td style={{ textAlign: "center" }}>  
                                    {data?.totalContent?.percentage 
                                    ? data.totalContent.percentage
                                    : 0}% 
                                  </td>

                                  <td style={{ color: "blue", wordBreak: "break-word" }}>
                                    {!data?.streakLastUpdated
                                      ? "User hasn't taken survey"
                                      : formatDate(data?.streakLastUpdated)}
                                  </td>
                                  <td style={{ color: "blue", textAlign: "center" }}>
                                    {data?.streakValueOnLastChange}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                          </>
                        </table>
                      </>
                    ) : (
                      <h3>No Active Contest</h3>
                    )}
                  </div>
                </>
              </div>
            </>
          ) : (
            <div className="No-data-statement">
              {" "}
              <h3>No Organizations yet</h3>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default UsersReport;